var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7852 25.1426H42.8209V21.214C42.8209 15.7926 38.4209 11.3926 32.9994 11.3926C27.578 11.3926 23.178 15.7926 23.178 21.214V25.1426H21.2137C19.053 25.1426 17.2852 26.9104 17.2852 29.0711V48.714C17.2852 50.8747 19.053 52.6426 21.2137 52.6426H44.7852C46.9459 52.6426 48.7137 50.8747 48.7137 48.714V29.0711C48.7137 26.9104 46.9459 25.1426 44.7852 25.1426ZM32.9994 42.8211C30.8387 42.8211 29.0709 41.0533 29.0709 38.8926C29.0709 36.7319 30.8387 34.964 32.9994 34.964C35.1602 34.964 36.928 36.7319 36.928 38.8926C36.928 41.0533 35.1602 42.8211 32.9994 42.8211ZM39.0887 25.1426H26.9102V21.214C26.9102 17.8551 29.6405 15.1247 32.9994 15.1247C36.3584 15.1247 39.0887 17.8551 39.0887 21.214V25.1426Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGroup);
export default __webpack_public_path__ + "static/media/lock-group.6f76b0d1f12f8e3e93b61efc7a5fb348.svg";
export { ForwardRef as ReactComponent };